/**
 * The apps HubHive ships to the phone stores, as descriptors.
 *
 * One OS-aware download CTA serves both apps (`AppDownloadCTA`), so what varies
 * between them — store URLs, display name, QR target — is data rather than a
 * second copy of the platform-detection logic. The store URLs themselves stay in
 * their existing canonical modules; this only composes them.
 */
import { CHAT_APP_STORE_URL, CHAT_PLAY_STORE_URL } from './chat-store-links'
import { APP_DOWNLOAD_URL } from './app-invite/app-invite.constants'
import { APP_STORE_URL, PLAY_STORE_URL } from './not-found/store-links'
import { getLoopSiteUrl } from './loop-site'

export interface StoreApp {
  /** Display name, spoken in the badge and QR accessible labels. */
  name: string
  appStoreUrl: string
  playStoreUrl: string
  /**
   * Where a desktop visitor's phone should land after scanning the QR: a web
   * page that re-runs platform detection, never one store directly, so the
   * phone that scans it picks its own store.
   */
  downloadUrl: string
}

export const HUBHIVE_APP: StoreApp = {
  name: 'HubHive',
  appStoreUrl: APP_STORE_URL,
  playStoreUrl: PLAY_STORE_URL,
  downloadUrl: APP_DOWNLOAD_URL,
}

export const LOOP_APP: StoreApp = {
  name: 'HubHive Loop',
  appStoreUrl: CHAT_APP_STORE_URL,
  playStoreUrl: CHAT_PLAY_STORE_URL,
  // The Loop site, not `hubhive.com/loop`: a phone with the main HubHive app
  // never reaches a `hubhive.com` page — the OS hands the link to that app,
  // which has no screen for it (see shared/loop-site.ts).
  downloadUrl: getLoopSiteUrl(),
}
